import {
  ISearchParams,
  SortByEnum,
  SortOrderEnum,
} from '../entity-data/entity-data.data';

export const ITEMS_PARTS_ROUTE = 'parts';
export const ITEMS_LABOR_ROUTE = 'labor';
export const ITEM_LIST_SEARCH_PARAMS_KEY = 'item_list_search_params';
export const PARTS_ITEM_LIST_SEARCH_PARAMS_KEY =
  'parts_item_list_search_params';
export const LABOR_ITEM_LIST_SEARCH_PARAMS_KEY =
  'labor_item_list_search_params';
export const ITEM_ACCEPT_VERSION = '3.0.0';
export const ITEM_SEARCH_ACCEPT_VERSION = '3.0.0';
export const ITEM_AUTOCOMPLETE_ACCEPT_VERSION = '1.0.0';

export const DEFAULT_SEARCH_PARAMS: ISearchParams = Object.freeze({
  sort_by: SortByEnum.description,
  sort_order: SortOrderEnum.asc,
});

export enum ItemFiltersEnum {
  parts = 'parts',
  labor = 'labor',
}

export enum ItemUnitTypesEnum {
  parts = 'parts',
  labor = 'labor',
  labor_days = 'labor_days',
  labor_hours = 'labor_hours',
}

export enum ItemAutoCompleteTypesEnum {
  codes = 'codes',
  names = 'names',
}
